// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import fetch from 'unfetch'
import Vue from 'vue';
// import {scaleLinear} from "d3-scale";
import * as d3 from "d3";
import money from 'v-money'
import responsive from 'vue-responsive'
import {
  Aside,
  Alert,
  Autocomplete,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Col,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Header,
  Input,
  Loading,
  Submenu,
  Row,
  Table,
  TableColumn,
  Tag,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Checkbox,
  MessageBox,
  Message,
  Notification,
  Form,
  FormItem,
  Select,
  Option,
  OptionGroup,
  Tooltip,
  Pagination,
  Dialog,
  Slider, Card,
} from 'element-ui';
import App from './App';
import { sync } from 'vuex-router-sync';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';

import store from './store';
import router from './router';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

// const unsync = sync(store, router) // done. Returns an unsync callback fn


sync(store, router);
locale.use(lang)

// Bulma UI components
Vue.use(Aside);
Vue.use(Alert);
Vue.use(Autocomplete);
Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(Card);
Vue.use(Col);
Vue.use(Container);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(DatePicker);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Header);
Vue.use(Input);
Vue.use(Loading);
Vue.use(Row);
Vue.use(Submenu);
Vue.use(Table);
Vue.use(Tag);
Vue.use(TableColumn);
Vue.use(Menu);
Vue.use(Main);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Checkbox);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(BreadcrumbItem);
Vue.use(Tooltip);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Slider);
Vue.use(d3);
Vue.use(money, {precision: 2})
// Vue.use(MessageBox);
// Vue.component(MessageBox.name,MessageBox);

// Importing prototypes
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.config.productionTip = false;

Vue.use(responsive);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  if (token) {
      return {
      headers: {
        ...headers,
        authorization: token ? `JWT ${token}` : "",
      }
    }
  }
});

// Apollo and graphql client configuration
// const defaultOptions = {
//   watchQuery: {
//     fetchPolicy: 'network-only',
//     errorPolicy: 'ignore',
//   },
//   query: {
//     fetchPolicy: 'network-only',
//     errorPolicy: 'all',
//   },
// }

const httpLink = new HttpLink({
  uri: `https://back.ixion.mx/graphql/`,
  //uri: `http://127.0.0.1:8000/graphql/`,
  fetch: fetch
});

const apolloClient = new ApolloClient ({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  // defaultOptions: defaultOptions,
  connectToDevTools: true,
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})
Vue.use(VueApollo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  apolloProvider,
  router,
  store,
  template: '<App/>',
  components: { App },
});

// Navigation guards
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const authUser = localStorage.getItem('token')
  const clientAuth = validClientSession(to)
  const validAuth = authUser || clientAuth
  if(requiresAuth && !validAuth) {
    window.location.assign('/')
  } else {
    next();
  }
})

const validClientSession = (route) => {
  if (route.params) {
    const clientPortfolioId = localStorage.getItem('portafolio_id')
    return clientPortfolioId === route.params.id
  }
}

// StartsWith Polyfill
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(search, pos) {
		return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	};
}

// Includes Polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}



// WEBPACK FOOTER //
// ./src/main.js